import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";

export const NewsletterForm = ({ variant = "footer" }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    try {
      const { data } = await api.post("/newsletter", { email });
      toast.success(data.message);
      setEmail("");
    } catch (err) {
      toast.error("Please enter a valid email");
    } finally {
      setLoading(false);
    }
  };

  if (variant === "footer") {
    return (
      <form onSubmit={submit} className="w-full max-w-sm" data-testid="newsletter-form-footer">
        <div className="flex items-stretch rounded-full bg-white/[0.08] border border-white/25 focus-within:border-gold-bright transition-colors duration-300 p-1 pl-4">
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email"
            className="flex-1 min-w-0 bg-transparent text-white placeholder-white/50 text-sm focus:outline-none"
            data-testid="newsletter-email-input"
          />
          <button
            type="submit"
            disabled={loading}
            aria-label="Subscribe"
            className="shrink-0 w-10 h-10 rounded-full metallic-gold text-charcoal flex items-center justify-center hover:brightness-110 transition-[filter] duration-300 disabled:opacity-60"
            data-testid="newsletter-submit"
          >
            <ArrowRight className="w-4 h-4" />
          </button>
        </div>
      </form>
    );
  }

  return (
    <form onSubmit={submit} className="flex w-full max-w-md" data-testid="newsletter-form">
      <input
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="Enter your email address"
        className="flex-1 min-w-0 border border-gray-300 border-r-0 px-4 py-3.5 text-sm focus:outline-none focus:border-pink"
        data-testid="newsletter-email-input"
      />
      <button
        type="submit"
        disabled={loading}
        className="shrink-0 bg-pink text-white border border-pink px-6 py-3.5 hover:bg-pink-hover transition-colors duration-300 flex items-center gap-2 text-xs uppercase tracking-[0.15em] disabled:opacity-60"
        data-testid="newsletter-submit"
      >
        {loading ? "..." : "Subscribe"} <ArrowRight className="w-4 h-4" />
      </button>
    </form>
  );
};
